import { render, staticRenderFns } from "./stepper.vue?vue&type=template&id=b94968d0&scoped=true&"
import script from "./stepper.vue?vue&type=script&lang=js&"
export * from "./stepper.vue?vue&type=script&lang=js&"
import style0 from "./stepper.vue?vue&type=style&index=0&id=b94968d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b94968d0",
  null
  
)

export default component.exports